import { ArrowUturnLeftIcon } from "@heroicons/react/20/solid"
import Button from "@src/components/Button"
import ErrorMessage from "@src/components/ErrorMessage"
import { FocusIcon } from "@src/icons"
import type { RefObject } from "react"

type QrScannerViewProps = {
  /** Returned by `useQrScanner`. */
  videoRef: RefObject<HTMLVideoElement | null>
  error: string | null
  onCancel: () => void
  headline?: string
  backLabel?: string
}

export default function QrScannerView({
  videoRef,
  error,
  onCancel,
  headline = "Point your camera at a recipient QR code.",
  backLabel = "Back",
}: QrScannerViewProps) {
  return (
    <div className="space-y-4">
      <div className="relative aspect-[0.8] overflow-hidden rounded-2xl border-2 border-gray-900 bg-gray-900 dark:border-white/10 dark:bg-gray-700">
        <video
          ref={videoRef}
          className="absolute inset-0 size-full object-cover"
          autoPlay
          muted
          playsInline
        />
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center px-5">
          <FocusIcon className="aspect-square w-full text-white" />
          <span className="text-balance text-center font-semibold text-base/5 text-white">
            {headline}
          </span>
        </div>
      </div>

      {error && (
        <ErrorMessage className="text-balance text-center">
          {error}
        </ErrorMessage>
      )}

      <Button size="xl" variant="secondary" fullWidth onClick={onCancel}>
        <ArrowUturnLeftIcon className="size-4.5 shrink-0" />
        {backLabel}
      </Button>
    </div>
  )
}
